import Vue from 'vue';
import VueFullPage from 'vue-fullpage.js';
import 'animate.css';
import VueGtag from 'vue-gtag';
import App from './App.vue';

Vue.use(VueGtag, {
  config: { id: 'G-8T7XX877RL' },
});

Vue.config.productionTip = false;
Vue.use(VueFullPage);

new Vue({
  render: (h) => h(App),
}).$mount('#app');
